import { makeStyles } from '@fluentui/react-components';
import { customPalette } from '../theme';

const useStyles = makeStyles({
    cardStyles: {
        width: 'auto',
        maxWidth: '100%',
        height: 'auto',
        padding: '12px 16px 0px',
        margin: '0 0 15px 0',
        backgroundColor: '#ffffff',
        gap: '5px',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        boxShadow: '0px 1.6px 0px 0px #00000021',
    },
    textStyles: {
        fontSize: '9px',
        fontWeight: 500,
        lineHeight: '12px',
        letterSpacing: '2.4px',
        textAlign: 'left',
        width: '150px',
        height: '12px',
        color: customPalette.blueDark,
    },
    currentReportNameTextStyles: {
        fontSize: '20px',
        fontWeight: 800,
        lineHeight: '28px',
        letterSpacing: '0.01em',
        textAlign: 'left',
        color: customPalette.blueDark,
    },
    statusText: {
        color: customPalette.blueDark,
    },
    topSection: {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        width: '100%',
        justifyContent: 'space-between',
    },
    buttonBar: {
        display: 'flex',
        flexDirection: 'row',
        gap: '5px',
    },
    buttonBarWrapper: {
        display: 'flex',
        alignSelf: 'stretch',
        gap: '5px',
    },
});

export const useCommonIndividualReportTableHeaderStyles = () => {
    return useStyles();
};
